import { defineStore } from 'pinia';

interface IPagingState {
  perPage: number;
  page: number;
  totalCount: number;
}

export const usePagingStore = defineStore('paging', {
  state: (): IPagingState => ({
    perPage: 10,
    page: 1,
    totalCount: 0,
  }),

  getters: {
    offsetRows: (state): number => (state.page - 1) * state.perPage,
    pageCount: (state): number => Math.ceil(state.totalCount / state.perPage),
  },

  actions: {
    setPerPage(count = 10) {
      this.perPage = count;
    },
    setPage(count = 1) {
      this.page = count;
    },
    setTotalCount(count = 0) {
      this.totalCount = count;
    },
  },
});

export default usePagingStore;
